import { useEffect } from 'react'
import { Sentiment } from 'sidecar-components/types'
import { useToast } from './useToast'
import type { ToastNotification } from '@/types'

/**
 * Custom hook to automatically show toast notifications based on state changes.
 *
 * This hook watches for toast-related state changes and automatically displays.
 * Useful for showing notifications after server actions complete.
 *
 * @example
 *   const [actionState] = useActionState(myAction, initialState)
 *   useToastNotification(actionState)
 */
export function useToastNotification(toastState?: ToastNotification | null) {
  const { showToast } = useToast()

  useEffect(() => {
    if (toastState?.show && toastState?.message) {
      showToast(toastState.message, toastState.sentiment || Sentiment.ACCENT)
    }
  }, [toastState, showToast])
}
